import type { DraggableAttributes } from '@dnd-kit/core';
import { useDndContext } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type React from 'react';
import type { CSSProperties } from 'react';

type DragHandleCellProps = {
  attributes: DraggableAttributes;
  listeners: ReturnType<typeof useSortable>['listeners'];
};

type DraggableRowProps = {
  row: any;
  children: React.ReactNode;
};

export const DragHandleCell: React.FC<DragHandleCellProps> = ({ attributes, listeners }) => {
  return (
    <div {...attributes} {...listeners} className="flex cursor-grab items-center">
      ⋮⋮
    </div>
  );
};

export const DraggableRow: React.FC<DraggableRowProps> = ({ row, children }) => {
  const { active } = useDndContext();
  const { attributes, listeners, transform, transition, setNodeRef, isDragging } = useSortable({ id: row.id });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: active ? transition : undefined,
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 1 : 0,
    position: 'relative',
  };

  return (
    <tr ref={setNodeRef} style={style} className="flex w-full cursor-pointer place-content-between border-grey-border border-b align-top last:border-b-0 hover:bg-gray-100">
      <td className="w-5">
        <DragHandleCell attributes={attributes} listeners={listeners} />
      </td>
      {children}
    </tr>
  );
};
